import React, { FC, useEffect, useRef } from 'react'
import styled, { keyframes } from 'styled-components'
import fonts from 'components/base-ui/Fonts'
import { Icon } from 'components/base-ui'
import { bounceIn } from 'react-animations'

interface Props {
  testId?: string
  id?: string
  iconName: string
  notifyNumber: number
  onCLickIcon: () => void
}

const BtnAddToCart: FC<Props> = ({ id, iconName, notifyNumber, onCLickIcon, testId }) => {
  const refBtnCart = useRef<HTMLDivElement>(null)
  const hasNotification = notifyNumber !== 0

  useEffect(() => {
    shackNotification()
  }, [notifyNumber])

  return (
    <div id={id} onClick={onCLickIcon}>
      <BtnAddToCartStyled className="button" ref={refBtnCart}>
        <Icon name={iconName} testId={testId} />
        {hasNotification ? <CircleNumber>{notifyNumber}</CircleNumber> : null}
      </BtnAddToCartStyled>
    </div>
  )

  function shackNotification() {
    if (refBtnCart && refBtnCart.current) {
      const currentTarget = refBtnCart.current

      currentTarget.classList.remove('-shake')
      setTimeout(() => currentTarget.classList.add('-shake'))
    }
  }
}

export default BtnAddToCart

const BounceAnimation = keyframes`${bounceIn}`

const BtnAddToCartStyled = styled.div<{ tertiary?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.24);
  background-color: ${(props) => (props.tertiary ? props.theme.colors.tertiary : props.theme.colors.primary)};
  transition: 0.6s;

  &.-shake {
    animation: ${BounceAnimation} 0.6s linear forwards;
  }

  i {
    font-size: 17px;
    color: white;
    transition: 0.6s;
  }

  .touch &.touch {
    transition: 0s;
    background-color: white;
    transform: scale(1.05);

    i {
      transition: 0s;
      color: ${(props) => (props.tertiary ? props.theme.colors.tertiary : props.theme.colors.primary)};
    }
  }
`

const CircleNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.orange};
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  font-weight: ${fonts.weight.bold};
  color: white;
`
